import { Wrapper, BorderBottomBox } from './styles'
import Text from 'components/shared/Text'
import { useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import Price from 'components/shared/Price'
import DeliveryOptions from './DeliveryOptions'
import DeliveryByEmailForm from './DeliveryByEmailForm'
import DeliveryByPostForm from './DeliveryByPostForm'
import { useAppSelector } from 'store/hooks'
import PersonalisedVoucher from './PersonalisedVoucher'

const VoucherDetails = () => {
    const { formatMessage } = useIntl()
    const { refundPrice } = useAppSelector((state) => state.selfcareCart)
    const { deliveryType } = useAppSelector((state) => state.order.shipping)

    return (
        <Wrapper>
            <BorderBottomBox pb={[24, 30]} isFullWidth>
                <Text variant="heading2">
                    {formatMessage({
                        id: 'selfcare.payment.voucher_header',
                        defaultMessage: 'Szczegóły Vouchera',
                    })}
                </Text>
            </BorderBottomBox>
            <BorderBottomBox
                pb={24}
                pt={24}
                mb={40}
                isFullWidth
                direction="row"
                justify="space-between"
            >
                <Box gap={10}>
                    <Text variant="body" color="grayscale_900">
                        {formatMessage({
                            id: 'selfcare.payment.voucher_refund',
                            defaultMessage: 'Zwrot środków:',
                        })}
                    </Text>
                    <Text variant="bodyExtraSmall" color="grayscale_700">
                        {formatMessage({
                            id: 'selfcare.payment.voucher_refund_subtitle',
                            defaultMessage:
                                'Zwrot otrzymasz w formie vouchera (ważnego przez rok).',
                        })}
                    </Text>
                </Box>
                <Price value={refundPrice} />
            </BorderBottomBox>
            <DeliveryOptions />
            {deliveryType === 'email' ? (
                <DeliveryByEmailForm />
            ) : (
                <DeliveryByPostForm />
            )}

            <PersonalisedVoucher />
        </Wrapper>
    )
}

export default VoucherDetails
